import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { OnsiteInterviewAdapters } from '../adapters';
import { ICreateOnsiteInterviewPayload } from '../types';

export const createOnsiteInterviews = async (
  payload: ICreateOnsiteInterviewPayload,
): Promise<void> => {
  const headers: { Authorization: string; 'x-office'?: string } = await getAuthHeaders();

  await tempMeeApi.post<void>(
    `/posting-service/postings/${payload.jobPostingId}/onsite-interviews`,
    OnsiteInterviewAdapters.toCreateOnsiteInterviewApiRequestBody(payload),
    {
      headers: {
        ...headers,
        'x-office': payload.officeId || headers['x-office'],
      },
    },
  );
};
